import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import React from "react";
import { DataFormField } from "types/models/input-field-type";
import { ColumnsEdit } from "types/models/column-table-edit";
import { Form, Input } from "antd";

const { INPUT, SELECT, DATE, CHECKBOX, TEXT_AREA, DATE_DISABLE_NO_DAY } =
  FIELD_TYPE;

const cssProps = {
  css: {
    xl: 12,
    lg: 12,
    md: 12,
    sm: 12,
    xs: 24,
  },
  labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
  wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
};

const dataField: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã BN",
    name: "maBenhNhan",
    ...cssProps,
    // disable: true,
  },
  // {
  //   type: INPUT,
  //   label: "Mã PK",
  //   name: "ngayKham",
  //   ...cssProps,
  // disable: true,
  //   rules: [{ required: true, message: "Chưa nhập mã phiếu khám" }],
  // },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Ngày khám",
    name: "ngayKham",
    ...cssProps,
    // disable: true,
    optionsTime: { format: FORMAT_TIME.dayFull, showTime: false },
    disableDate: false,
    needConfirm: false,
  },
  {
    type: INPUT,
    label: "Họ và tên",
    name: "hoTen",
    // disable: true,
    ...cssProps,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Ngày sinh",
    name: "ngaySinh",
    // disable: true,
    ...cssProps,
    needConfirm: false,
    optionsTime: { format: FORMAT_TIME.dayFull, showTime: false },
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "soDienThoai",
    // disable: true,
    ...cssProps,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Ngày nhận kính",
    name: "ngayNhanKinh",
    disableDate: false,
    needConfirm: false,
    optionsTime: { format: FORMAT_TIME.dayFull, showTime: false },
    ...cssProps,
  },
  {
    type: INPUT,
    label: "Gọi hẹn tái khám",
    needConfirm: false,
    // optionsTime: { format: FORMAT_TIME.dayFull, showTime: false },
    name: "ngayTaiKham",
    ...cssProps,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Ngày khám gần nhất",
    name: "ngayKhamGanNhat",
    disableDate: false,
    needConfirm: false,
    optionsTime: { format: FORMAT_TIME.dayFull, showTime: false },
    ...cssProps,
  },
  {
    type: INPUT,
    label: "Nhân viên",
    name: "cuNhanKhucXa",
    // disable: true,
    ...cssProps,
  },

  {
    type: INPUT,
    label: "Bác sĩ",
    name: "bacSi",
    // disable: true,
    ...cssProps,
  },
  // {
  //   type: DATE_DISABLE_NO_DAY,
  //   disableDate: false,
  //   label: "Ngày gọi",
  //   needConfirm: false,
  //   optionsTime: { format: FORMAT_TIME.dayFull, showTime: false },
  //   name: "ngayGoi",
  //   ...cssProps,
  // },
  {
    type: TEXT_AREA,
    label: "Tình trạng hiện tại",
    name: "tinhTrang",
    ...cssProps,
  },
  {
    type: TEXT_AREA,
    label: "Địa chỉ",
    name: "diaChi",
    ...cssProps,
  },
];

const columnTable: any = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: "40px",
    render: (text, record, index) => index + 1,
    align: "center",
  },
  {
    title: "Nhân viên",
    dataIndex: "nhanVien",
    key: "nhanVien",
    // width: '100px',
    align: "center",
  },
  {
    title: "Gọi hẹn tái khám",
    dataIndex: "goiHenTaiKham",
    key: "goiHenTaiKham",
    // width: '100px',
    align: "center",
  },
  {
    title: "Ngày gọi",
    dataIndex: "ngayGoi",
    key: "ngayGoi",
    // width: '8%',
    align: "left",
  },
  {
    title: "Tình trạng hiện tại",
    dataIndex: "tinhTrang",
    key: "tinhTrang",
    // width: '100px',
    align: "center",
  },
];
// const sharedOnCell = (_, index: number) => {
//   if (index === 3) {
//     return { colSpan: 0 };
//   }

//   return {};
// };
// const columnsSecond: ColumnsEdit = [
//   {
//     title: "Nội dung",
//     dataIndex: "noiDung",
//     key: "noiDung",
//     width: 150,
//     align: "left",
//     onCell: (_, index) => ({
//       colSpan: index !==3  ? 2 : 1,
//     }),
//   },
//   {
//     title: "MP",
//     dataIndex: "mp",
//     key: "mp",
//     width: 50,
//     type: INPUT,
//     align: "center",
//     render: (v, r, i) => (
//       <Form.Item name={["ttTruocDieuTri", "mp", i]}>
//         <Input />
//       </Form.Item>
//     ),
//     onCell: (_, index) => ({
//       colSpan: index ==3  ? 2 : 1,
//     }),
//   },
//   {
//     title: "MP",
//     dataIndex: "mp",
//     key: "mp",
//     width: 50,
//     type: INPUT,
//     align: "center",
//     render: (v, r, i) => (
//       <Form.Item name={["ttTruocDieuTri", "mp", i]}>
//         <Input />
//       </Form.Item>
//     ),
//   },
//   {
//     title: "MT",
//     dataIndex: "mt",
//     key: "mt",
//     width: 50,
//     align: "center",
//     render: (v, r, i) => (
//       <Form.Item name={["ttTruocDieuTri", "mt", i]}>
//         <Input />
//       </Form.Item>
//     ),
//     onCell: (_, index) => ({
//       colSpan: index !==3  ? 2 : 1,
//     }),
//   },
// ];

const columnsFitting: any = [
  {
    title: "Nội dung",
    dataIndex: "noiDung",
    key: "noiDung",
    // width: '100px',
    align: "center",
  },
  {
    title: "MP",
    dataIndex: "mp",
    key: "mp",
    // width: '100px',
    align: "center",
  },
  {
    title: "MT",
    dataIndex: "mt",
    key: "mt",
    // width: '100px',
    align: "center",
  },
];

const columnsResult: any = [
  {
    title: "Lần khám",
    dataIndex: "lanKham",
    key: "lanKham",
    // width: '100px',
    align: "center",
  },
  {
    title: "Nội dung",
    dataIndex: "noiDung",
    key: "noiDung",
    // width: '100px',
    align: "center",
  },
  {
    title: "MP",
    dataIndex: "mp",
    key: "mp",
    // width: '100px',
    align: "center",
  },
  {
    title: "MT",
    dataIndex: "mt",
    key: "mt",
    // width: '100px',
    align: "center",
  },
  {
    title: "Ghi chú",
    dataIndex: "ghiChu",
    key: "ghiChu",
    // width: '100px',
    align: "center",
  },
];
const dataKQDT = [
  {
    key: 1,
    noiDung: "Thị lực không kính Khúc xạ",
    lanKham: "Ngày 19/01/2022",
    sauNgay: "(Sau 1 ngày)",
    mp: "",
    mt: "",
    edit: false,
  },
  {
    key: 2,
    noiDung: "Thị lực không kính Khúc xạ",
    sauNgay: "(Sau 4 ngày)",
    lanKham: "Ngày 22/01/2022",
    mp: "",
    edit: false,
    mt: "",
  },
  {
    key: 3,
    noiDung: "Thị lực không kính Khúc xạ",
    sauNgay: "(Sau 1 tháng)",
    lanKham: "Ngày 19/02/2022",
    mp: "",
    edit: false,
    mt: "",
  },
  {
    key: 4,
    noiDung: "Thị lực không kính Khúc xạ",
    lanKham: `Ngày`,
    sauNgay: "(Sau 3 tháng)",
    edit: false,
    mp: "",
    mt: "",
  },
];

export { dataField, columnTable, columnsFitting, columnsResult, dataKQDT };
